import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import { getField, updateField } from "vuex-map-fields";
import { Common } from "@/helper/common";

Vue.use(Vuex);
let sourceSite = "YOH_SCE_Application";
let referralSource = "501";
let referredBy = "0";
let referredByEmpId = "0";
let gaTracking = "";
let email = "";
let title = "";
let mobilePrefix = "";
let mobile = "";
let firstname = "";
let lastname = "";
let sourceSiteToAppend = "";
//source - we don't care about coookie for sourceSite
if (Common.getQuerystring("source") != "") {
  sourceSite = sourceSite + "_" + Common.getQuerystring("source");
  Common.setCookie("source", sourceSite, 30);
} else if (Common.getCookie("source") != null)
  sourceSite = sourceSite + "_" + Common.getCookie("source");

  if (Common.getQuerystring("source") != "") {
    sourceSiteToAppend= "_" + Common.getQuerystring("source");
  } else if (Common.getCookie("source") != null)
    sourceSiteToAppend ="_" + Common.getCookie("source");

//referralSource
if (Common.getQuerystring("refSrc") != "") {
  referralSource = Common.getQuerystring("refSrc");
  Common.setCookie("refSrc", referralSource, 30);
} else if (Common.getCookie("refSrc") != null)
  referralSource = Common.getCookie("refSrc");

//referredBy
if (Common.getQuerystring("refBy") != "") {
  referredBy = Common.getQuerystring("refBy");
  Common.setCookie("refBy", referredBy, 30);
} else if (Common.getCookie("refBy") != null)
  referredBy = Common.getCookie("refBy");

//referredByEmployee
if (Common.getQuerystring("emp") != "") {
  referredByEmpId = Common.getQuerystring("emp");
  Common.setCookie("emp", referredByEmpId, 30);
} else if (Common.getCookie("emp") != null)
  referredByEmpId = Common.getCookie("emp");

//ga tracking
if (
  Common.getQuerystring("utm_source") != "" &&
  Common.getQuerystring("utm_source") != null
) {
  gaTracking +=
    (gaTracking != "" ? ", " : "") +
    "utm_source = " +
    Common.getQuerystring("utm_source");
  Common.setCookie("utm_source", Common.getQuerystring("utm_source"), 30);
} else if (
  Common.getCookie("utm_source") != null &&
  Common.getCookie("utm_source") != ""
)
  gaTracking +=
    (gaTracking != "" ? ", " : "") +
    "utm_source = " +
    Common.getCookie("utm_source");

if (
  Common.getQuerystring("utm_medium") != "" &&
  Common.getQuerystring("utm_medium") != null
) {
  gaTracking +=
    (gaTracking != "" ? ", " : "") +
    "utm_medium = " +
    Common.getQuerystring("utm_medium");
  Common.setCookie("utm_medium", Common.getQuerystring("utm_medium"), 30);
} else if (
  Common.getCookie("utm_medium") != null &&
  Common.getCookie("utm_medium") != ""
)
  gaTracking +=
    (gaTracking != "" ? ", " : "") +
    "utm_medium = " +
    Common.getCookie("utm_medium");

if (
  Common.getQuerystring("utm_content") != "" &&
  Common.getQuerystring("utm_content") != null
) {
  gaTracking +=
    (gaTracking != "" ? ", " : "") +
    "utm_content = " +
    Common.getQuerystring("utm_content");
  Common.setCookie("utm_content", Common.getQuerystring("utm_content"), 30);
} else if (
  Common.getCookie("utm_content") != null &&
  Common.getCookie("utm_content") != ""
)
  gaTracking +=
    (gaTracking != "" ? ", " : "") +
    "utm_content = " +
    Common.getCookie("utm_content");

if (
  Common.getQuerystring("utm_term") != "" &&
  Common.getQuerystring("utm_term") != null
) {
  gaTracking +=
    (gaTracking != "" ? ", " : "") +
    "utm_term = " +
    Common.getQuerystring("utm_term");
  Common.setCookie("utm_term", Common.getQuerystring("utm_term"), 30);
} else if (
  Common.getCookie("utm_term") != null &&
  Common.getCookie("utm_term") != ""
)
  gaTracking +=
    (gaTracking != "" ? ", " : "") +
    "utm_term = " +
    Common.getCookie("utm_term");

if (
  Common.getQuerystring("utm_campaign") != "" &&
  Common.getQuerystring("utm_campaign") != null
) {
  gaTracking +=
    (gaTracking != "" ? ", " : "") +
    "utm_campaign = " +
    Common.getQuerystring("utm_campaign");
  Common.setCookie("utm_campaign", Common.getQuerystring("utm_campaign"), 30);
} else if (
  Common.getCookie("utm_campaign") != null &&
  Common.getCookie("utm_campaign") != ""
)
  gaTracking +=
    (gaTracking != "" ? ", " : "") +
    "utm_campaign = " +
    Common.getCookie("utm_campaign");

if (
  Common.getQuerystring("GCLID") != "" &&
  Common.getQuerystring("GCLID") != null
) {
  gaTracking +=
    (gaTracking != "" ? ", " : "") +
    "GCLID = " +
    decodeURIComponent(Common.getQuerystring("GCLID"));
  Common.setCookie("GCLID", Common.getQuerystring("GCLID"), 30);
} else if (Common.getCookie("GCLID") != null && Common.getCookie("GCLID") != "")
  gaTracking +=
    (gaTracking != "" ? ", " : "") +
    "GCLID = " +
    decodeURIComponent(Common.getCookie("GCLID"));

    //pre fill email, first/lastname
if (Common.getCookie("email") != null) email = Common.getCookie("email");
if (Common.getCookie("firstname") != null)
  firstname = Common.getCookie("firstname");
if (Common.getCookie("lastname") != null)
  lastname = Common.getCookie("lastname");
if (Common.getCookie("title") != null)
  title = Common.getCookie("title");
if (Common.getCookie("mobilePrefix") != null)
  mobilePrefix = Common.getCookie("mobilePrefix");
if (Common.getCookie("mobile") != null)
  mobile = Common.getCookie("mobile");

export default new Vuex.Store({
  state: {
    tabs: [
      {
        name: "Webinars and Events",
        icon: "ti-video-clapper",
        isActive: true,
      },
      {
        name: "Register for Webinar / Virtual Event",
        icon: "ti-user",
        isActive: false,
      },
      {
        name: "Tell us about your plans",
        icon: "ti-home",
        isActive: false,
      },
      {
        name: "Register with our partner",
        icon: "ti-email",
        isActive: false,
      },
    ],
    budgetToValueMapping: {
      2550: "25000",
      2551: "75000",
      2552: "150000",
      2553: "250000",
      2554: "350000",
      2555: "450000",
      2556: "600000",
      2645: ""
    },
    campaignCountryCodeMapping: {
      "ABG":	"AU",
      "CANBG":	"CA", 
      "CBG":	"CY", 
      "FBG":	"FR", 
      "GBG":	"GR", 
      "IBG":	"IT", 
      "IRBG":	"IE", 
      "NBG":	"NZ",
      "PBG":	"PT",
      "SBG":	"ES",
      "TBG":	"TR",
      "UBG":	"US",
      "UKBG":	"GB"
    },
    currentActive: 0,
    totalTabs: 0,
    form: {
      title: title,
      firstName: firstname,
      lastName: lastname,
      email: email,
      webinar: "",
      webinarSource: "",
      dob: "",
      addressLine: "",
      postCode: "",
      buildingNo: "",
      city: "",
      country: {
        CountryId: 5,
        CRMCountryId: 225,
        CountryName: "UNITED KINGDOM",
        ShowOnSite: true,
        TwoCharCode: "GB",
      },
    postcodeAnywhereId:"",
    street:"",
    district:"",
    countyState:"",
    useDetails:false,
      telPrefix: "",
      telephone: "",
      mobilePrefix: mobilePrefix,
      mobile: mobile,
      titleAdditional: "",
      firstNameAdditional: "",
      lastNameAdditional: "",
      emailAdditional: "",
      dobAdditional: "",
      addressLineAdditional: "",
      postCodeAdditional: "",
      buildingNoAdditional: "",
      cityAdditional: "",
      countryAdditional: {
        CountryId: 5,
        CRMCountryId: 225,
        CountryName: "UNITED KINGDOM",
        ShowOnSite: true,
        TwoCharCode: "GB",
      },
      postcodeAnywhereIdAdditional:"",
      streetAdditional:"",
      districtAdditional:"",
      countyStateAdditional:"",
      useDetailsAdditional:false,
      mobilePrefixAdditional: "",
      mobileAdditional: "",
      sourceCurrency: "",
      targetCurrency: "",
      transferAmount: "",
      transferDestination: "",
      reasonForTransfer: "2474",
      countryBuyingIn: "",
      region: "",
      regionId: "",
      propertyBudget: "",
      funding: "",
      timescale: "",
      tripPlannedOn: null,
      opportunityTypes: [],
      terms: false,
      jointAccount:"no",
      sameAddressAsMain:true,
      sourceSite: sourceSite,
      sourceSiteForPreference: "YOH_SCE_Application_PREF",
      referralSource: referralSource,
      referredBy: referredBy,
      referredByEmpId: referredByEmpId,
      gaTracking: gaTracking,
      bizId: 22,
      bizIdYOH: 21,
      clientType: "PC",
      isContactExist: false,
      twoFaMessage:"",
      virtualEventOptIn: false,
      virtualEventToOptin:null,
      sourceSiteToAppend:sourceSiteToAppend,
    },
    userIdentities:[],
    actions: {
      showMobileVerification: false,
      isFInalStep: false,
      hasOTPAccess: false,
      skippedMobileVerification: false,
      mobileVerified: false,
      hideNavigation: false,
      showThankYouForYOH:false
    },
    messageInfo: {
      show: false,
      message: "",
      isSuccess: false,
    },
    countries: [],
    webinars: [],
    registerables: [],
    countriesOfInterest: [],
    countryCodes: [],
    currencies: [],
    budgetValues: [],
    timeScales: [],
    fundingOptions: [],
    rfts:[],
    contactId: null,
    mainContactId:null,
    additionalContactId:null,
    skipSmartStep: false,
    showYOHLogo:true,
    jwtToken:null,
    mainUserGBGStatus:"",
    additionalUserGBGStatus:""
  },
  getters: {
    getField,
    getTabs: (state) => {
      return state.tabs;
    },
    getCurrentActive: (state) => {
      return state.currentActive;
    },
    getTotalTabs: (state) => {
      return state.totalTabs;
    },
    getActions: (state) => {
      return state.actions;
    },
    getFormData: (state) => {
      return state.form;
    },
    getUserIdentities:(state)=>{
      return state.userIdentities;
    },
    getMessageInfo: (state) => {
      return state.messageInfo;
    },
    getCountries: (state) => {
      return state.countries;
    },
    getWebinars: (state) => {
      return state.webinars;
    },
    getRegisterables: (state) => {
      return state.registerables;
    },
    getCountriesOfInterest: (state) => {
      return state.countriesOfInterest;
    },
    getCountryCodes: (state) => {
      return state.countryCodes;
    },
    getCurrencies: (state) => {
      return state.currencies;
    },
    getContactId: (state) => {
      return state.contactId;
    },
    getMainContactId: (state) => {
      return state.mainContactId;
    },
    getAdditionalContactId: (state) => {
      return state.additionalContactId;
    },
    getBudgetValues: (state) => {
      return state.budgetValues;
    },
    getTimeScales: (state) => {
      return state.timeScales;
    },
    getFundingOptions: (state) => {
      return state.fundingOptions;
    },
    getOpportunityTypes: (state) => {
      return state.form.opportunityTypes;
    },
    skipSmartStep: (state) => {
      return state.skipSmartStep;
    },
    showYOHLogo:(state)=>{
      return state.showYOHLogo;
    },
    getJwtToken:(state)=>{
      return state.jwtToken;
    },
    getRfts: (state) => {
      return state.rfts;
    },
    getMainUserGBGStatus:(state)=>{
      return state.mainUserGBGStatus;
    },
    getAdditionalUserGBGStatus:(state)=>{
      return state.additionalUserGBGStatus;
    },
    isMainUserGBGVerified:(state)=>{
      let isAlreadyVerified=false;
      if (state.mainUserGBGStatus!="")
      {
       if (state.mainUserGBGStatus == "verified" || state.mainUserGBGStatus == "invalid")
        isAlreadyVerified= true;
      }
      return isAlreadyVerified;
    },
    isAdditionalUserGBGVerified:(state)=>{
      let isAlreadyVerified=false;
      if (state.additionalUserGBGStatus!="")
      {
       if (state.additionalUserGBGStatus == "verified" || state.additionalUserGBGStatus == "invalid")
        isAlreadyVerified= true;
      }
      return isAlreadyVerified;
    },
    showHeaderForSmart:(state)=>{
      return (state.currentActive==3 && !state.skipSmartStep);
    },
    showThankYouForYOH:(state)=>{
      return state.actions.showThankYouForYOH;
    }
  },
  mutations: {
    updateField,
    setTabs: (state, payload) => {
      state.tabs = payload;
    },
    setCurrentActive: (state, payload) => {
      state.currentActive = payload;
    },
    setTotalTabs: (state, payload) => {
      state.totalTabs = payload;
    },
    showHideMobileVerification: (state, payload) => {
      state.actions.showMobileVerification = payload;
    },
    showYOHLogo: (state, payload) => {
      state.showYOHLogo = payload;
    },
    setFinalStep: (state, payload) => {
      state.actions.isFInalStep = payload;
    },
    setMessageInfo: (state, payload) => {
      state.messageInfo = payload;
    },
    setCountries: (state, payload) => {
      state.countries = payload;
    },
    setWebinars: (state, payload) => {
      state.webinars = payload;
    },
    setRegisterables: (state, payload) => {
      state.registerables = payload;
    },
    setCountriesOfInterest: (state, payload) => {
      state.countriesOfInterest = payload;
    },
    setCountryCodes: (state, payload) => {
      state.countryCodes = payload;
    },
    setCurrencies: (state, payload) => {
      state.currencies = payload;
    },
    setBudgetValues: (state, payload) => {
      state.budgetValues = payload;
    },
    setTimeScales: (state, payload) => {
      state.timeScales = payload;
    },
    setFundtinOptions: (state, payload) => {
      state.fundingOptions = payload;
    },
    setOpportunityTypes: (state, payload) => {
      state.form.opportunityTypes = payload;
    },
    setContactId: (state, payload) => {
      state.contactId = payload;
    },
    setMainContactId: (state, payload) => {
      state.mainContactId = payload;
    },
    setAdditionalContactId: (state, payload) => {
      state.additionalContactId = payload;
    },
    setSkipSmartStep: (state, payload) => {
      state.skipSmartStep = payload;
    },
    setContactExist: (state, payload) => {
      state.form.isContactExist = payload;
    },
    setHideNavigation: (state, payload) => {
      state.actions.hideNavigation = payload;
    },
    setWebinarSource: (state, payload) => {
      let additionalSource="";
      if (Common.getQuerystring("source") != "")
        additionalSource = "_" + Common.getQuerystring("source");
      else if (Common.getCookie("source") != null)
        additionalSource = "_" + Common.getCookie("source");

      state.form.webinarSource = payload + additionalSource;
    },
    setWebinar: (state, payload) => {
      state.form.webinar = payload;
    },
    setVirtualEvent: (state, payload) => {
      state.form.virtualEventToOptin = payload;
    },
    setTwofaMessage: (state, payload) => {
      state.form.twoFaMessage = payload;
    },
    addUserIdentity(state,payload) {
      if (state.userIdentities.length)
      {
        let foundIndex = state.userIdentities.findIndex(el=> el.contactId==payload.contactId);
        if (foundIndex>-1)
        {
          state.userIdentities[foundIndex] = payload;
        }else
        state.userIdentities.push(payload);

      }else
        state.userIdentities.push(payload);
    },
    setJwtToken(state,payload){
      state.jwtToken=payload
    },
    resetHeader(state){
      state.showHeaderForSmart=false;
    },
    setShowThankYouForYOH(state,payload){
      
      state.actions.showThankYouForYOH=payload;
    },
    setRfts: (state, payload) => {
      state.rfts = payload;
    },
    setMainUserGBGStatus:(state, payload)=>{
      state.mainUserGBGStatus= payload;
    },
    setAdditionalUserGBGStatus:(state, payload)=>{
      state.additionalUserGBGStatus= payload;
    }
  },
  actions: {
    setTabs: ({ commit }, payload) => {
      commit("setTabs", payload);
    },
    setCurrentActive: ({ commit }, payload) => {
      commit("setCurrentActive", payload);
    },
    setTotalTabs: ({ commit }, payload) => {
      commit("setTotalTabs", payload);
    },
    showHideMobileVerification: ({ commit }, payload) => {
      commit("showHideMobileVerification", payload);
    },
    showYOHLogo:({commit}, payload)=>{
      commit("showYOHLogo", payload);
    },
    setFinalStep: ({ commit }, payload) => {
      commit("setFinalStep", payload);
    },
    setMessageInfo: ({ commit }, payload) => {
      commit("setMessageInfo", payload);
    },
    setContactId: ({ commit }, payload) => {
      commit("setContactId", payload);
    },
    setMainContactId: ({ commit }, payload) => {
      commit("setMainContactId", payload);
    },
    setAdditionalContactId: ({ commit }, payload) => {
      commit("setAdditionalContactId", payload);
    },
    addUserIdentity: ({ commit }, payload) => {
      commit("addUserIdentity", payload);
    },
    setSkipSmartStep: ({ commit }, payload) => {
      commit("setSkipSmartStep", payload);
    },
    setContactExist: ({ commit }, payload) => {
      commit("setContactExist", payload);
    },
    setHideNavigation: ({ commit }, payload) => {
      commit("setHideNavigation", payload);
    },
    setWebinarSource: ({ commit }, payload) => {
      commit("setWebinarSource", payload);
    },
    setCountries: ({ commit }, payload) => {
      commit("setCountries",payload);
    },
    setWebinars: ({ commit }, payload) => {
      commit("setWebinars", payload);
    },
    setRegisterables: ({ commit }, payload) => {
      commit("setRegisterables", payload);
    },
    setCountriesOfInterest: ({ commit }, payload) => {
      commit("setCountriesOfInterest", payload);
    },
    setWebinar: ({ commit }, payload) => {
      commit("setWebinar", payload);
    },
    setVirtualEvent: ({ commit }, payload) => {
      commit("setVirtualEvent", payload);
    },
    setTwofaMessage: ({ commit }, payload) => {
      commit("setTwofaMessage", payload);
    },
    setCountryCodes: ({ commit }) => {
      axios
        .get(process.env.VUE_APP_API_URL + "/client/countryCodeList")
        .then((res) => {
          const countryCodes = res.data.data;
          commit("setCountryCodes", countryCodes);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    setCurrencies: ({ commit }) => {
      axios
        .get(process.env.VUE_APP_API_URL + "/client/currencyListing")
        .then((res) => {
          const currencies = res.data.data;
          commit("setCurrencies", currencies);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    setBudgetValues: ({ commit }) => {
      axios
        .get(
          process.env.VUE_APP_API_URL +
            "/client/GetBudgetAndTimeScale?selectionName=budgetRange"
        )
        .then((res) => {
          const result = res.data.data.sort((a, b) =>
            a.Sequence > b.Sequence ? 1 : -1
          );
          commit("setBudgetValues", result);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    setTimeScales: ({ commit }) => {
      axios
        .get(
          process.env.VUE_APP_API_URL +
            "/client/GetBudgetAndTimeScale?selectionName=timeScale"
        )
        .then((res) => {
          const result = res.data.data
            // .filter((d) => d.CodesId != 2548)
            .sort((a, b) => (a.Sequence > b.Sequence ? 1 : -1));
          commit("setTimeScales", result);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    setOpportunityTypes: ({ commit }) => {
      axios
        .get(process.env.VUE_APP_API_URL + "/client/GetOpportunities")
        .then((res) => {
          const result = res.data.data
            .filter((d) => d.FriendlyNames != null)
            .map((d) => ({ ...d, Selected: false }));
          commit("setOpportunityTypes", result);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    setFundtinOptions: ({ commit }) => {
      axios
        .get(process.env.VUE_APP_API_URL + "/client/GetFundingOptions")
        .then((res) => {
          const result = res.data.data;

          const fundingOptionsOrder = [2471, 2469, 2473]
          const sortedFundingOptions = result.sort((a, b) => {
            return fundingOptionsOrder.indexOf(a.CodesId) - fundingOptionsOrder.indexOf(b.CodesId);
          })

          commit("setFundtinOptions", sortedFundingOptions);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    setJwtToken: ({ commit }, payload) => {
      commit("setJwtToken", payload);
    },
    resetHeader: ({ commit }) => {
      commit("resetHeader");
    },
    setShowThankYouForYOH: ({ commit },payload) => {
      commit("setShowThankYouForYOH",payload);
      if (payload==true)
      {
        Common.trackSignupEvent();
        console.log("trackSignupEvent");
      }
    },
    setRfts: ({ commit }) => {
      axios
        .get(
          process.env.VUE_APP_API_URL + "/client/rftListing?ClientType=Private"
        )
        .then((res) => {
          const rfts = res.data.data.sort((a, b) =>
            a.CodesId > b.CodesId ? 1 : -1
          );
          commit("setRfts", rfts);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    setMainUserGBGStatus: ({commit},payload)=>{
      commit("setMainUserGBGStatus",payload);
    },
    setAdditionalUserGBGStatus: ({commit},payload)=>{
      commit("setAdditionalUserGBGStatus",payload);
    }
  },
  modules: {},
});
